module.exports = __webpack_public_path__ + "img/img14.c9d931e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img14.jpg
// module id = 279
// module chunks = 0